import React from 'react';
import { shape, string } from 'prop-types';
import { Table } from '@devexpress/dx-react-grid-material-ui';

import ScoringContextMenu from './ScoringContextMenu';

const ScoringActionCell = ({ row, ...props }) => (
    <Table.Cell key={row.id} {...props}>
        <ScoringContextMenu error={row} />
    </Table.Cell>
);

ScoringActionCell.defaultProps = {
    row: {}
};

ScoringActionCell.propTypes = {
    row: shape({
        recalculationStatus: string
    })
};

export default ScoringActionCell;
